import { defer, EMPTY, expand, from, map, Observable, reduce } from "rxjs";
import { BinanceUsdmRestClient, BinanceWebsocketClient } from "../../../core/market";
import { createStringNumberMap, mergeStringNumberMaps, parseFloatSafe } from "../../../core/func"
import { GetIncomeHistoryParams, IncomeHistory, isWsFormattedFuturesUserDataAccountUpdate, WsUserDataEvents } from "libs/binance-api/src";

export class BinanceUsdmBalanceRestProvider {

  constructor(private rest: BinanceUsdmRestClient) {}

  /**
   * @deprecated
   */
  requestBalance() {
    return from(this.rest.getAccountInformationV3()).pipe(
      map(data => parseFloatSafe(data.totalWalletBalance)),
    )
  }

  requestBalances() {
    return from(this.rest.getBalanceV3()).pipe(
      map(data => {
        const map: Record<string, number> = {}
        data.forEach(row => map[row.asset] = parseFloatSafe(row.balance))
        return map
      }),
    )
  }

  /**
   * @deprecated
   */
  requestPnl(startTime: number) {
    const params: GetIncomeHistoryParams = {
      incomeType: 'REALIZED_PNL',
      startTime: startTime,
      limit: 1000,
    }
    const req = defer(() => this.rest.getIncomeHistory(params))
    return req.pipe(
      expand(data => {
        if (params.limit && data.length >= params.limit) {
          params.startTime = data[data.length - 1].time + 1  // последняя запись самая свежая
          return req
        }
        return EMPTY
      }),
      map(data => data.reduce((sum, item) => sum + parseFloatSafe(item.income), 0)),
      reduce((acc, n) => acc += n, 0),
    )
  }

  requestPnls(startTime: number) {
    const params: GetIncomeHistoryParams = {
      incomeType: 'REALIZED_PNL',
      startTime: startTime,
      limit: 1000,
    }
    const req = defer(() => this.rest.getIncomeHistory(params))
    return req.pipe(
      expand(data => {
        if (params.limit && data.length >= params.limit) {
          params.startTime = data[data.length - 1].time + 1  // последняя запись самая свежая
          return req
        }
        return EMPTY
      }),
      map(data => data.filter(row => row.symbol) as Required<IncomeHistory>[]),
      map(data => createStringNumberMap(data, 'symbol', 'income')),
      reduce((acc, data) => mergeStringNumberMaps(acc, data), {} as Record<string, number>)
    )
  }

}

export class BinanceUsdmBalanceWebsocketProvider {

  constructor(private rest: BinanceUsdmRestClient, private ws: BinanceWebsocketClient) {}

  /**
   * @deprecated
   */
  realtimeBalance() {
    return new Observable<number>(subscriber => {
      const f = (data: WsUserDataEvents) => {
        if (isWsFormattedFuturesUserDataAccountUpdate(data) && data.wsMarket == 'usdm' && data.updateData.updatedBalances.length) {
          const restPr = new BinanceUsdmBalanceRestProvider(this.rest)
          restPr.requestBalance().subscribe(subscriber)
        }
      }

      this.ws.on('formattedUserDataMessage', f)
      return () => this.ws.off('formattedUserDataMessage', f)
    })
  }

  realtimeBalances() {
    return new Observable<Record<string, number>>(subscriber => {
      const f = (data: WsUserDataEvents) => {
        if (isWsFormattedFuturesUserDataAccountUpdate(data) && data.wsMarket == 'usdm' && data.updateData.updatedBalances.length) {
          subscriber.next(createStringNumberMap(data.updateData.updatedBalances, 'asset', 'walletBalance'))
        }
      }

      this.ws.on('formattedUserDataMessage', f)
      return () => this.ws.off('formattedUserDataMessage', f)
    })
  }

  realtimePnlChange() {
    return new Observable<Record<string, number>>(subscriber => {
      const f = (data: WsUserDataEvents) => {
        if (data.wsMarket == 'usdm' && data.eventType == 'ORDER_TRADE_UPDATE' && data.order) {
          subscriber.next({[data.order.symbol]: data.order.realisedProfit})
        }
      }

      this.ws.on('formattedUserDataMessage', f)
      return () => this.ws.off('formattedUserDataMessage', f)
    })
  }

}
